
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/1st-dfa-annual-conference",
      function () {
        return require("private-next-pages/events/1st-dfa-annual-conference/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/1st-dfa-annual-conference"])
      });
    }
  